<template>
  <div
    class="notification_overlay"
    :class="{ active: $store.state.show_notification }"
    @click="hide"
  >
    <div
      class="notification"
      :class="[
        { active: $store.state.show_notification },
        $store.state.notification_type,
      ]"
    >
      <img src="@/assets/img/notification_info_icon.svg" class="info" alt="" />
      <img src="@/assets/img/alert_info_icon.svg" class="alert" alt="" />
      <img src="@/assets/img/succes_info_icon.svg" class="succes_img" alt="" />

      <p>{{ $store.state.notification_content }}</p>

      <button class="close hover_op" @click="hide"></button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show_notifiaction: true,
    };
  },

  methods: {
    hide() {
      this.$store.commit("hideNotification");
    },
  },

  updated() {
    setTimeout(() => {
      this.hide();
    }, 3000);
  },
};
</script>

<style lang="scss" scoped>
.notification_overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  padding: 16px;
  opacity: 0;
  transition: opacity 180ms;
  pointer-events: none;
  display: none;

  &.active {
    display: flex;
    opacity: 1;
    transition: opacity 180ms;
    pointer-events: all;
  }
}

.notification {
  border-radius: 16px;
  background-color: #fff;
  padding: 20px;
  display: flex;
  align-items: center;
  opacity: 0;
  transition: opacity 180ms;
  pointer-events: none;

  @media all and (max-width: 767px) {
    padding: 16px;
  }

  &.active {
    opacity: 1;
    transition: opacity 180ms;
    pointer-events: all;
  }

  p {
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 30px;
    text-align: left;
    margin-left: 16px;
    margin-right: 16px;
  }

  img {
    height: 22px;
    display: none;
  }

  .close {
    flex: none;
    width: 32px;
    height: 32px;
    background: url("../assets/img/mob_close_menu_icon.svg") no-repeat center /
      26px auto;
  }

  &:not(.alert):not(.succes) {
    .info {
      display: block;
    }
  }

  &.alert {
    background-color: #fc5a12;

    p {
      color: #fdfdfd;
    }

    .close {
      background: url("../assets/img/close_white.svg") no-repeat center / 26px
        auto;
    }

    .alert {
      display: block;
    }
  }

  &.succes {
    background-color: #b6c869;

    p {
      color: #fdfdfd;
    }

    .close {
      background: url("../assets/img/close_white.svg") no-repeat center / 26px
        auto;
    }

    .succes_img {
      display: block;
    }
  }
}
</style>